import QuoteModule from 'containers/purchase/modules/axis_quote_module/quote_module'
import quoteState from 'containers/purchase/modules/axis_quote_module/quote_state'
import AxisVehiclesModule from 'containers/purchase/modules/axis_vehicles_module/axis_vehicles_module'
import axisVehiclesState from 'containers/purchase/modules/axis_vehicles_module/axis_vehicles_state'
import AxisDetailsModule from 'containers/purchase/modules/axis_details_module/axis_details_module'
import axisDetailsState from 'containers/purchase/modules/axis_details_module/axis_details_state'
import i18n from 'i18n/config'

const reservationMapper = (ctx) => {
  const vehicle = ctx.vehicle
  const service_level = vehicle.service_level.code

  return {
    event_id: 'axis',
    ticket_types: [],
    params: {
      quote_form: ctx.quote_form.values,
      vehicle: {...vehicle, fees_selected: ctx.vehicleFeeQuantities[service_level]},
      details_values: ctx.detailsValues
    }
  }
}

const config = (params) => {
  const {external_api_config} = params

  let steps = {}

  steps.quoteStep = {
    component: QuoteModule,
    componentProps: {
      formName: 'quote_form',
    },
    currentStep: 'quote',
    target: '#purchase.vehiclesStep',
    autoNext: false,
    states: quoteState,
    context: {
      tickets: []
    }
  }

  steps.vehiclesStep = {
    component: AxisVehiclesModule,   
    autoNext: false,
    states: axisVehiclesState,
    context: {
      event: {
        id: 'axis'
      },
      tickets: []
    }
  }

  steps.detailsStep = {
    component: AxisDetailsModule,
    autoNext: false,
    states: axisDetailsState,
    context: {
      detailsValues: []
    }
  }

  return {
    reservationMapper: reservationMapper,
    steps: steps,
    params: params,
  }
}

export default config
